var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDomain = function SvgDomain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.365 20.576v-17.5h9.5v4h9.77v13.5zm1.5-1.5h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm4 12h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm4 12h8.27v-10.5h-8.27v2.5h2.192v1.5h-2.192v2.5h2.192v1.5h-2.192zm4.385-6.5v-1.5h1.5v1.5zm0 4v-1.5h1.5v1.5z"
  })));
};
export default SvgDomain;